/**
 * 오프라인 모드 표시 배너.
 *
 * navigator.onLine === false 또는 offline 이벤트 수신 시 상단에 배너 표시.
 * online 이벤트 시 자동 숨김 + "다시 연결되었어요" 알림.
 *
 * 영구지침: docs/develop/pwa/pwa-spec.md §3.8
 */
import { useEffect, useState } from 'react'
import { WifiOff } from 'lucide-react'

export default function OfflineBanner() {
  const [offline, setOffline] = useState<boolean>(() =>
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  )

  useEffect(() => {
    const handleOffline = () => setOffline(true)
    const handleOnline = () => setOffline(false)

    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)

    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
    }
  }, [])

  if (!offline) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-30 flex items-center justify-center gap-2 bg-yellow-50 px-4 py-2 text-xs font-medium text-yellow-900"
    >
      <WifiOff className="h-3.5 w-3.5" aria-hidden="true" />
      <span>오프라인 모드 · 최근에 본 정보만 볼 수 있어요</span>
    </div>
  )
}
